var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "ErrorConfig-edit" } },
    [
      _c(
        "IForm",
        {
          ref: "formInline",
          attrs: {
            model: _vm.edit,
            elem: _vm.errorElem,
            rules: _vm.errorRule,
            "label-width": 125,
            submit: false,
          },
          on: { "on-submit": _vm.toSubmit },
        },
        [
          _c(
            "div",
            [
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "9" } },
                    [
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "24" } },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    label: "名称",
                                    prop: "name",
                                    required: "",
                                  },
                                },
                                [
                                  _c("Input", {
                                    attrs: {
                                      type: "text",
                                      placeholder: "请输入名称",
                                      maxlength: "50",
                                    },
                                    model: {
                                      value: _vm.edit.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.edit, "name", $$v)
                                      },
                                      expression: "edit.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "24" } },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: { label: "适用性别", prop: "gender" },
                                },
                                [
                                  _c(
                                    "RadioGroup",
                                    {
                                      attrs: { prop: "gender" },
                                      model: {
                                        value: _vm.edit.gender,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.edit, "gender", $$v)
                                        },
                                        expression: "edit.gender",
                                      },
                                    },
                                    _vm._l(_vm.genderList, function (item) {
                                      return _c(
                                        "Radio",
                                        {
                                          key: item.code,
                                          attrs: { label: item.code },
                                          nativeOn: {
                                            dblclick: function ($event) {
                                              $event.preventDefault()
                                              return (() => {
                                                _vm.edit.gender = null
                                              }).apply(null, arguments)
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(item.name))]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "24" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "适用年龄" } },
                                [
                                  _c(
                                    "Row",
                                    [
                                      _c(
                                        "Col",
                                        { attrs: { span: "11" } },
                                        [
                                          _c("Input", {
                                            attrs: {
                                              type: "number",
                                              placeholder: "请输入开始年龄",
                                              maxlength: "2",
                                            },
                                            model: {
                                              value: _vm.edit.startAge,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.edit,
                                                  "startAge",
                                                  $$v
                                                )
                                              },
                                              expression: "edit.startAge",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "Col",
                                        {
                                          staticStyle: {
                                            "text-align": "center",
                                          },
                                          attrs: { span: "2" },
                                        },
                                        [_vm._v("~")]
                                      ),
                                      _c(
                                        "Col",
                                        { attrs: { span: "11" } },
                                        [
                                          _c("Input", {
                                            attrs: {
                                              type: "number",
                                              placeholder: "请输入结束年龄",
                                              maxlength: "2",
                                            },
                                            model: {
                                              value: _vm.edit.endAge,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.edit,
                                                  "endAge",
                                                  $$v
                                                )
                                              },
                                              expression: "edit.endAge",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "24" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "适用既往病史" } },
                                [
                                  _c("MyCheckBox", {
                                    attrs: {
                                      enumList: _vm.pastMedicalHistoryList,
                                      "ignore-list": ["1"],
                                      dataList: _vm.pastMedicalHistorys,
                                      dataStr: _vm.edit.pastMedicalHistory,
                                    },
                                    on: {
                                      "update:dataList": function ($event) {
                                        _vm.pastMedicalHistorys = $event
                                      },
                                      "update:data-list": function ($event) {
                                        _vm.pastMedicalHistorys = $event
                                      },
                                      "update:dataStr": function ($event) {
                                        return _vm.$set(
                                          _vm.edit,
                                          "pastMedicalHistory",
                                          $event
                                        )
                                      },
                                      "update:data-str": function ($event) {
                                        return _vm.$set(
                                          _vm.edit,
                                          "pastMedicalHistory",
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "24" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "适用过敏史" } },
                                [
                                  _c(
                                    "RadioGroup",
                                    {
                                      model: {
                                        value: _vm.edit.allergyHistory,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.edit,
                                            "allergyHistory",
                                            $$v
                                          )
                                        },
                                        expression: "edit.allergyHistory",
                                      },
                                    },
                                    _vm._l(
                                      _vm.allergyHistoryList,
                                      function (item) {
                                        return _c(
                                          "Radio",
                                          {
                                            key: item.code,
                                            attrs: { label: item.code },
                                            nativeOn: {
                                              dblclick: function ($event) {
                                                $event.preventDefault()
                                                return (() => {
                                                  _vm.edit.other = null
                                                }).apply(null, arguments)
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(item.value))]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "24" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "适用传染病接触史" } },
                                [
                                  _c(
                                    "RadioGroup",
                                    {
                                      model: {
                                        value: _vm.edit.infectionHistory,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.edit,
                                            "infectionHistory",
                                            $$v
                                          )
                                        },
                                        expression: "edit.infectionHistory",
                                      },
                                    },
                                    _vm._l(
                                      _vm.infectionHistoryList,
                                      function (item) {
                                        return _c(
                                          "Radio",
                                          {
                                            key: item.code,
                                            attrs: { label: item.code },
                                            nativeOn: {
                                              dblclick: function ($event) {
                                                $event.preventDefault()
                                                return (() => {
                                                  _vm.edit.other = null
                                                }).apply(null, arguments)
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(item.value))]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "24" } },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: {
                                    label: "健康评价",
                                    prop: "evaluation",
                                    required: "",
                                  },
                                },
                                [
                                  _c("Input", {
                                    attrs: {
                                      type: "textarea",
                                      placeholder: "请输入健康评价",
                                      rows: 2,
                                      maxlength: "100",
                                    },
                                    model: {
                                      value: _vm.edit.evaluation,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.edit, "evaluation", $$v)
                                      },
                                      expression: "edit.evaluation",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "24" } },
                            [
                              _c(
                                "FormItem",
                                [
                                  _c(
                                    "RadioGroup",
                                    {
                                      attrs: { prop: "gender" },
                                      model: {
                                        value: _vm.edit.showError,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.edit, "showError", $$v)
                                        },
                                        expression: "edit.showError",
                                      },
                                    },
                                    _vm._l(_vm.showErrorList, function (item) {
                                      return _c(
                                        "Radio",
                                        {
                                          key: item.code,
                                          attrs: { label: item.code },
                                          nativeOn: {
                                            dblclick: function ($event) {
                                              $event.preventDefault()
                                              return (() => {
                                                _vm.edit.showError = null
                                              }).apply(null, arguments)
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(item.value))]
                                      )
                                    }),
                                    1
                                  ),
                                  _vm.edit.showError == 1
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            color: "#f3673d",
                                            "font-size": "14px",
                                          },
                                        },
                                        [_vm._v("模版：血压偏低")]
                                      )
                                    : _vm._e(),
                                  _vm.edit.showError == 2
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            color: "#f3673d",
                                            "font-size": "14px",
                                          },
                                        },
                                        [_vm._v("模版：血压偏低:舒张压 22mmhg")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "24" } },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: { label: "异常原因", prop: "reason" },
                                },
                                [
                                  _c("Input", {
                                    attrs: {
                                      type: "textarea",
                                      placeholder: "请输入异常原因",
                                      rows: 3,
                                      maxlength: "200",
                                      "show-word-limit": "",
                                    },
                                    model: {
                                      value: _vm.edit.reason,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.edit, "reason", $$v)
                                      },
                                      expression: "edit.reason",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "24" } },
                            [
                              _c(
                                "FormItem",
                                {
                                  attrs: { label: "意见建议", prop: "propose" },
                                },
                                [
                                  _c("Input", {
                                    attrs: {
                                      type: "textarea",
                                      placeholder: "请输入意见建议",
                                      rows: 5,
                                      maxlength: "500",
                                      "show-word-limit": "",
                                    },
                                    model: {
                                      value: _vm.edit.propose,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.edit, "propose", $$v)
                                      },
                                      expression: "edit.propose",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "24" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "转诊建议" } },
                                [
                                  _c("el-switch", {
                                    attrs: {
                                      "inactive-value": 1,
                                      "active-value": 2,
                                    },
                                    model: {
                                      value: _vm.edit.referral,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.edit, "referral", $$v)
                                      },
                                      expression: "edit.referral",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.edit.referral === 2
                        ? _c(
                            "Row",
                            [
                              _c(
                                "Col",
                                { attrs: { span: "24" } },
                                [
                                  _c(
                                    "FormItem",
                                    {
                                      attrs: {
                                        label: "转诊原因",
                                        prop: "referralReason",
                                        required:
                                          _vm.edit.referral &&
                                          _vm.edit.referral === 2,
                                      },
                                    },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          type: "textarea",
                                          placeholder: "请输入转诊原因",
                                          rows: 2,
                                          maxlength: "100",
                                          "show-word-limit": "",
                                        },
                                        model: {
                                          value: _vm.edit.referralReason,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.edit,
                                              "referralReason",
                                              $$v
                                            )
                                          },
                                          expression: "edit.referralReason",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.edit.referral === 2
                        ? _c(
                            "Row",
                            [
                              _c(
                                "Col",
                                { attrs: { span: "24" } },
                                [
                                  _c(
                                    "FormItem",
                                    {
                                      attrs: {
                                        label: "转诊机构",
                                        prop: "referralInstitutionId",
                                        required:
                                          _vm.edit.referral &&
                                          _vm.edit.referral === 2,
                                      },
                                    },
                                    [
                                      _c(
                                        "Select",
                                        {
                                          model: {
                                            value:
                                              _vm.edit.referralInstitutionId,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.edit,
                                                "referralInstitutionId",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "edit.referralInstitutionId",
                                          },
                                        },
                                        _vm._l(
                                          _vm.referralInstitutions,
                                          function (item) {
                                            return _c(
                                              "Option",
                                              {
                                                key: item.id,
                                                attrs: { value: item.id },
                                              },
                                              [_vm._v(_vm._s(item.name))]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.edit.referral === 2
                        ? _c(
                            "Row",
                            [
                              _c(
                                "Col",
                                { attrs: { span: "24" } },
                                [
                                  _c(
                                    "FormItem",
                                    {
                                      attrs: {
                                        label: "转诊科室",
                                        prop: "referralDepartmentId",
                                        required:
                                          _vm.edit.referral &&
                                          _vm.edit.referral === 2,
                                      },
                                    },
                                    [
                                      _c(
                                        "Select",
                                        {
                                          model: {
                                            value:
                                              _vm.edit.referralDepartmentId,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.edit,
                                                "referralDepartmentId",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "edit.referralDepartmentId",
                                          },
                                        },
                                        _vm._l(
                                          _vm.referralDepartments,
                                          function (item) {
                                            return _c(
                                              "Option",
                                              {
                                                key: item.id,
                                                attrs: { value: item.id },
                                              },
                                              [_vm._v(_vm._s(item.name))]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "15" } },
                    [
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "12" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "条件" } },
                                [
                                  _c(
                                    "Select",
                                    {
                                      model: {
                                        value: _vm.edit.logicalCondition,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.edit,
                                            "logicalCondition",
                                            $$v
                                          )
                                        },
                                        expression: "edit.logicalCondition",
                                      },
                                    },
                                    _vm._l(_vm.conditionList, function (item) {
                                      return _c(
                                        "Option",
                                        {
                                          key: item.value,
                                          attrs: { value: item.value },
                                        },
                                        [_vm._v(_vm._s(item.label))]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("Col", { attrs: { span: "1" } }),
                          _c(
                            "Col",
                            { attrs: { span: "11" } },
                            [
                              _c(
                                "el-row",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small", type: "primary" },
                                      on: { click: _vm.onAdd },
                                    },
                                    [_vm._v("添加")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small", type: "danger" },
                                      on: { click: _vm.onClear },
                                    },
                                    [_vm._v("清空")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._l(this.edit.conditions, function (item, index) {
                        return _c(
                          "Row",
                          { staticStyle: { "margin-bottom": "10px" } },
                          [
                            _c("Col", { attrs: { span: "2" } }),
                            _c(
                              "Col",
                              { attrs: { span: "5" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      placeholder: "请选择",
                                      filterable: "",
                                      size: "small",
                                      transfer: "true",
                                      "popper-append-to-body": false,
                                    },
                                    model: {
                                      value: item.fieldId,
                                      callback: function ($$v) {
                                        _vm.$set(item, "fieldId", $$v)
                                      },
                                      expression: "item.fieldId",
                                    },
                                  },
                                  _vm._l(_vm.fields, function (fieldItem) {
                                    return _c(
                                      "el-option",
                                      {
                                        key: fieldItem.fieldId,
                                        staticStyle: {
                                          width: "100%",
                                          "z-index": "9999",
                                        },
                                        attrs: {
                                          label:
                                            fieldItem.fieldName +
                                            (fieldItem.label != item.alias
                                              ? "[" + item.alias + "]"
                                              : ""),
                                          value: fieldItem.fieldId,
                                        },
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.onField(fieldItem, item)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticStyle: { float: "left" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                fieldItem.fieldName +
                                                  (fieldItem.label != item.alias
                                                    ? "[" + item.alias + "]"
                                                    : "")
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            style: {
                                              float: "right",
                                              color: _vm.convertBusinessType(
                                                fieldItem.businessType
                                              ).color,
                                              "font-size": "13px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.convertBusinessType(
                                                  fieldItem.businessType
                                                ).name
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("Col", { attrs: { span: "1" } }),
                            _c(
                              "Col",
                              { attrs: { span: "3" } },
                              [
                                _c(
                                  "Select",
                                  {
                                    attrs: { placeholder: "条件" },
                                    model: {
                                      value: item.conditionSymbolId,
                                      callback: function ($$v) {
                                        _vm.$set(item, "conditionSymbolId", $$v)
                                      },
                                      expression: "item.conditionSymbolId",
                                    },
                                  },
                                  _vm._l(item.symbols, function (symbolItem) {
                                    return _c(
                                      "Option",
                                      {
                                        key: symbolItem.conditionSymbolId,
                                        attrs: {
                                          value: symbolItem.conditionSymbolId,
                                        },
                                      },
                                      [_vm._v(_vm._s(symbolItem.label))]
                                    )
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("Col", { attrs: { span: "1" } }),
                            _c(
                              "Col",
                              { attrs: { span: "8" } },
                              [
                                item.elementType === 1 ||
                                item.elementType === 2 ||
                                item.elementType === 3 ||
                                item.elementType === 15
                                  ? _c("Input", {
                                      attrs: {
                                        type: "text",
                                        placeholder: "请输入",
                                      },
                                      model: {
                                        value: item.conditionValue,
                                        callback: function ($$v) {
                                          _vm.$set(item, "conditionValue", $$v)
                                        },
                                        expression: "item.conditionValue",
                                      },
                                    })
                                  : item.elementType === 10 ||
                                    item.elementType === 11
                                  ? _c("el-cascader", {
                                      attrs: {
                                        size: "small",
                                        placeholder: "请选择",
                                        options: item.treeOptions,
                                      },
                                      on: {
                                        change: (value) =>
                                          _vm.changeCascader(value, item),
                                      },
                                      model: {
                                        value: item.conditionValue,
                                        callback: function ($$v) {
                                          _vm.$set(item, "conditionValue", $$v)
                                        },
                                        expression: "item.conditionValue",
                                      },
                                    })
                                  : _c(
                                      "Select",
                                      {
                                        attrs: { placeholder: "请选择" },
                                        model: {
                                          value: item.conditionValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              item,
                                              "conditionValue",
                                              $$v
                                            )
                                          },
                                          expression: "item.conditionValue",
                                        },
                                      },
                                      _vm._l(
                                        item.options,
                                        function (symbolItem) {
                                          return _c(
                                            "Option",
                                            {
                                              key: symbolItem.id,
                                              attrs: { value: symbolItem.id },
                                            },
                                            [_vm._v(_vm._s(symbolItem.name))]
                                          )
                                        }
                                      ),
                                      1
                                    ),
                              ],
                              1
                            ),
                            _c("Col", { attrs: { span: "1" } }),
                            _c(
                              "Col",
                              { attrs: { span: "3" } },
                              [
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "small",
                                          type: "danger",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onDelete(index)
                                          },
                                        },
                                      },
                                      [_vm._v("删除")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }